export default __webpack_public_path__ + "static/hotblack-events2-49d1e6debad4cb88f674866fd9df60cc.jpg";